import script from "./AdminProfile.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminProfile.vue?vue&type=script&setup=true&lang=js"

import "./AdminProfile.vue?vue&type=style&index=0&id=5a7515fb&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5a7515fb"]])

export default __exports__